import { render } from "./Cerere.vue?vue&type=template&id=1ae68f5e&scoped=true&ts=true"
import script from "./Cerere.ts?vue&type=script&lang=ts"
export * from "./Cerere.ts?vue&type=script&lang=ts"

import "./Cerere.vue?vue&type=style&index=0&id=1ae68f5e&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae68f5e"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QCard,QCardSection,QBtn,QInput,QPopupProxy,QDate,QIcon,QSelect,QItem,QItemSection,QItemLabel,QLinearProgress,QImg,QBanner,QTooltip,QDialog,QBar,QSpace});qInstall(script, 'directives', {ClosePopup});
